export type MediaKind = "image" | "video" | "audio" | null;

const IMAGE_EXTENSIONS = new Set(["jpg", "jpeg", "png", "webp", "gif", "bmp", "svg"]);
const VIDEO_EXTENSIONS = new Set(["mp4", "webm", "mov", "m4v", "ogg"]);
const AUDIO_EXTENSIONS = new Set(["mp3", "wav", "ogg", "m4a", "aac", "flac"]);

export function getFileExtension(path: string): string {
  const cleanPath = path.split("?")[0].split("#")[0];
  const lastSegment = cleanPath.split("/").pop() ?? "";
  const dotIndex = lastSegment.lastIndexOf(".");
  if (dotIndex === -1) return "";
  return lastSegment.slice(dotIndex + 1).toLowerCase();
}

/** Resolve render kind from declared question_type / answer_type only. */
export function resolveMediaKindFromType(mediaType?: string): MediaKind {
  if (mediaType === "image" || mediaType === "qr_code") return "image";
  if (mediaType === "video") return "video";
  if (mediaType === "audio") return "audio";
  return null;
}

/** Resolve render kind from file extension (used as fallback after a load error). */
export function resolveMediaKindFromExtension(mediaPath?: string): MediaKind {
  if (!mediaPath?.trim()) return null;
  const ext = getFileExtension(mediaPath);
  if (IMAGE_EXTENSIONS.has(ext)) return "image";
  if (VIDEO_EXTENSIONS.has(ext)) return "video";
  if (AUDIO_EXTENSIONS.has(ext)) return "audio";
  return null;
}

export function resolveAssetUrl(media?: string | null, retryKey = 0): string {
  if (!media?.trim()) return "";
  const trimmed = media.trim();
  if (/^(https?:|data:|blob:)/i.test(trimmed)) {
    if (!retryKey) return trimmed;
    const separator = trimmed.includes("?") ? "&" : "?";
    return `${trimmed}${separator}r=${retryKey}`;
  }
  const baseUrl = String(import.meta.env.VITE_BASE_CDN_URL || "").replace(/\/$/, "");
  const path = trimmed.replace(/^\//, "");
  const url = baseUrl ? `${baseUrl}/${path}` : `/${path}`;
  if (!retryKey) return url;
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}r=${retryKey}`;
}

export function buildMediaUrl(media: string, retryKey = 0): string {
  return resolveAssetUrl(media, retryKey);
}
